import { connect } from 'react-redux';
import { HotelRoomOffersSkeleton } from '@lt/components';
import { getIsMobile } from 'src/store/view/selectors';
import { getVisibleNightsColumnsCount } from '../../store/selectors/view';
import { SEARCHER_STATE } from '../../store/constants/searcher';
import { getSearcherState } from '../../store/selectors/searcher';
import { getHotelRoulette } from '../../store/selectors/hotel';

const mapStateToProps = (state) => {
  const searcherState = getSearcherState(state);
  const columns =
    searcherState === SEARCHER_STATE.INITIAL
      ? 3
      : getVisibleNightsColumnsCount(state);
  return {
    columns,
    isMobile: getIsMobile(state),
    showGallery: !getHotelRoulette(state),
  };
};

export default connect(mapStateToProps)(HotelRoomOffersSkeleton);
